<template>
  <div style="font-size:30px;">
    <div class="toptitle">
      <h5 style="font-size: 20px;left: 190px;position: absolute;top: -15px;">
        优房联卖管理系统
      </h5>
    </div>
    <div class="content">
      <div class="login">
        <div>
          <h4 style="font-size:15px;">用户登录</h4>
        </div>
        <el-divider></el-divider>
        <div style="margin-top: 15px;">
          <el-input v-model="rybh" placeholder="请输入用户名...">
            <i slot="prefix" class="el-input__icon el-icon-s-custom"></i>
          </el-input>
        </div>
        <div style="margin-top: 25px;">
          <el-input v-model="pwd" show-password placeholder="请输入密码...">
            <i slot="prefix" class="el-input__icon el-icon-key"></i>
          </el-input>
        </div>
        <div style="margin-top: 55px;">
          <el-button
            type="primary"
            style="width:200px"
            @click="login"
            :loading="isbtnLoading"
            >登 录</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入去除空格工具
import md5 from "js-md5";
var utilPost, op;
export default {
  name: "LoginIndex",
  components: { md5 },
  data() {
    return {
      loginType: "XTGLY",
      rybh: "",
      pwd: "",
      op: "",
      isbtnLoading: false
    };
  },
  created() {
    this.op = "adminLoginGl";
    this.utilPost = this.$util.handler;
  },
  methods: {
    login() {
      // 验证输入
      if (!this.rybh || this.rybh.trim() === "") {
        alert("请输入用户名");
        return;
      }
      if (!this.pwd || this.pwd.trim() === "") {
        alert("请输入密码");
        return;
      }

      this.isbtnLoading = true;
      var busData = {
        pwd: this.pwd,
        rybh: this.rybh
      };
      var methodName = "mainLoad";
      var paramData = {
        headerData: {
          op: this.op, //反射名称
          methodName: methodName //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        this.isbtnLoading = false;
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        
        // 存储用户信息到 localStorage
        window.localStorage.setItem("uis", JSON.stringify(data.content));
        
        // 根据权限ID跳转到不同页面
        const QXID = data.content.QXID;
        if (QXID === "0") {
          // 系统管理员：跳转到收房成交管理（默认第一个菜单）
          this.$router.push({ path: "/sfOrderGlIndex" });
        } else if (QXID === "1") {
          // 财务管理员：跳转到收房成交管理
          this.$router.push({ path: "/sfOrderGlIndex" });
        } else if (QXID === "2") {
          // 人事管理员：跳转到装饰管理（默认页面）
          this.$router.push({ path: "/accessoriesGlIndex" });
        } else {
          // 其他权限：默认跳转到收房成交管理
          this.$router.push({ path: "/sfOrderGlIndex" });
        }
      }).catch(err => {
        this.isbtnLoading = false;
        alert("登录失败，请重试");
        console.error(err);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.toptitle {
  width: 100%;
  height: 10%;
  background: #f6f6f6;
  position: absolute;
}
.content {
  width: 100%;
  height: 70%;
  background-image: url("../../assets/bj.jpg");
  position: absolute;
  top: 10%;
  background-size: 100% 100%;
}
.fotter {
  width: 100%;
  height: 40%;
  background: #f6f6f6;
  position: absolute;
  top: 60%;
}
.login {
  position: absolute;
  width: 299px;
  background: #fdfdfd;
  height: 350px;
  right: 50px;
  top: 100px;
  z-index: 99;
  border-radius: 10px;
  padding-left: 15px;
  padding-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/view/loginIndex/LoginIndex.vue